<script setup lang="ts">
import { ref } from "vue";

interface Slide {
  id: number;
  class?: string;
  url: string;
  thumbUrl: string;
  thumbWidth: number;
  thumbHeight: number;
  width: number;
  height: number;
  alt: string;
  caption: string;
}

const props = defineProps({
  slideshow: Array as () => Slide[],
});

const currentSlide = ref(0);
const showSlideshow = ref(false); // Control visibility of the slideshow

// Show the slideshow after 1 second
setTimeout(() => {
  showSlideshow.value = true;
}, 300);

function slideTo(val: number) {
  currentSlide.value = val;
}

function determineOrientation(width: number, height: number): string {
  return width > height ? "landscape" : "portrait";
}
</script>

<template>
  <Transition name="fade-slide" appear>
    <div v-if="showSlideshow" class="gallery-slideshow">
      <Carousel
        id="gallery"
        v-model="currentSlide"
        :items-to-show="1"
        :wrap-around="true"
      >
        <Slide
          v-for="(slide, index) in props?.slideshow"
          :key="`slide-${slide.id}-${index}`"
        >
          <div
            class="carousel__item"
            :class="[
              slide.class || '',
              determineOrientation(slide.width, slide.height),
            ]"
          >
            <NuxtPicture
              loading="lazy"
              :src="slide?.url"
              :width="slide?.width"
              :height="slide?.height"
              :alt="slide?.alt"
              sizes="sm:100vw md:50vw lg:1000px"
            />
            <caption v-if="slide?.caption" class="caption">
              {{
                slide?.caption
              }}
            </caption>
          </div>
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
      <div id="thumbWrap">
        <Carousel
          id="thumbnails"
          v-model="currentSlide"
          :items-to-show="10"
          :wrap-around="true"
        >
          <Slide
            v-for="(slide, index) in props?.slideshow"
            :key="`thumb-${slide.id}-${index}`"
          >
            <div class="carousel__item" @click.prevent="slideTo(index)">
              <NuxtImg
                :class="slide?.class || ''"
                loading="lazy"
                :src="slide?.thumbUrl"
                :width="slide?.thumbWidth || 200"
                :height="slide?.thumbHeight || 200"
                :alt="slide?.alt"
                sizes="200px"
              />
            </div>
          </Slide>
        </Carousel>
      </div>
    </div>
  </Transition>
</template>
